import React, { useEffect, useState } from 'react';
import './orders.css';
import Order from './Order';
import { connect } from 'react-redux';
import { db } from '../firebase';
const mapStateToProps = (state) => {
  return {
    user: state.User,
  };
};

function Orders(props) {
  const [orders, setOrders] = useState([]);
  useEffect(() => {
    if (props?.user) {
      db.collection('users')
        .doc(props?.user?.user?.uid)
        .collection('orders')
        .orderBy('created', 'desc')
        .onSnapshot((snapshot) => {
          setOrders(
            snapshot.docs.map((doc) => ({
              id: doc.id,
              data: doc.data(),
            }))
          );
          console.log('orders', orders);
        });
    } else {
      setOrders([]);
    }
  }, [props.user?.user?.uid]);

  return (
    <div className="orders">
      {console.log(orders)}
      {orders?.map((orderItem, index) => {
        return (
          <div>
            <Order orderItem={orderItem.data} key={index}></Order>
          </div>
        );
      })}
    </div>
  );
}

export default connect(mapStateToProps)(Orders);
